import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { MessagingMarketingOrg } from '@wetags/messaging-marketing';
import { FeatureAccessPermissions } from '@frontend/feature-access';

type UseOrgLevelLocationSelectorReturn = {
  isOrgLevelSelector: boolean;
  permission: Permission;
};

/**
 * Central place for the org-level location selector: reads the org-scoped `org-level-selector` wetag
 * (messaging-marketing namespace) and derives the ACL permission for the campaign's channel (undefined
 * campaignType = email). The wetag is async — while it resolves it reads `false`, so consumers fall back
 * to the legacy selector until it turns on (graceful for the common not-enabled case).
 */
export const useOrgLevelLocationSelector = (campaignType?: CampaignType): UseOrgLevelLocationSelectorReturn => {
  const [isOrgLevelSelector] = MessagingMarketingOrg.useWetag('org-level-selector');

  return {
    isOrgLevelSelector,
    permission:
      campaignType === CampaignType.SMS
        ? FeatureAccessPermissions.bulkTexting
        : FeatureAccessPermissions.emailMarketing,
  };
};
